<template>
  <header-menu />
  <div>
    <div class="headSculpture">
      <img src="@/assets/indexLogo.png" alt="" />
    </div>
    <div class="title">欢迎使用花集AI精灵</div>
  </div>
  <div class="tabs">
    <div
      class="item"
      @click="data.loginType = 'codeLogin'"
      :class="data.loginType === 'codeLogin' ? 'quitItem' : ''"
    >
      <div>验证码登录/注册</div>
    </div>
    <div
      class="item"
      @click="data.loginType = 'passwordLogin'"
      :class="data.loginType === 'passwordLogin' ? 'quitItem' : ''"
    >
      <div>密码登录</div>
    </div>
  </div>
  <div v-if="data.loginType === 'codeLogin'">
    <van-field
      v-model="data.phone"
      @update:model-value="data.phoneValue"
      :class="data.phoneTextFlag ? 'four' : ''"
      type="number"
      class="textCorol"
      :clearable="true"
      placeholder="请输入手机号"
      label-align="top"
      maxlength="11"
    />
    <van-field
      v-model="data.phoneCode"
      @update:model-value="data.phoneCodeValue"
      :class="data.phoneCodeValueFlag ? 'four' : ''"
      type="number"
      maxlength="6"
      class="textCorol"
      :clearable="true"
      placeholder="请输入验证码"
      label-align="top"
    >
      <template #button>
        <div class="btn" @click="data.getCode">
          {{ store.codeTimeFlag ? "获取验证码" : store.codeTime + "秒后重发" }}
        </div>
      </template>
    </van-field>
  </div>
  <div v-else>
    <input type="text" style="height: 0; border: none; position: absolute" />
    <input
      type="password"
      style="height: 0; border: none; position: absolute"
    />
    <van-field
      v-model="data.phone"
      @update:model-value="data.phoneValue"
      :class="data.phoneTextFlag ? 'four' : ''"
      type="number"
      class="textCorol"
      :clearable="true"
      placeholder="请输入手机号"
      label-align="top"
      maxlength="11"
    />
    <van-field
      v-model="data.password"
      @update:model-value="data.passwordValue"
      @input="data.input"
      :class="data.passwordValueFlag ? 'four' : ''"
      class="textCorol"
      :type="data.passwordType"
      :clearable="true"
      placeholder="请输入密码"
      label-align="top"
      maxlength="20"
    >
      <template #button>
        <div class="switch">
          <img
            @click="data.passwordType = ''"
            v-if="data.passwordType === 'password'"
            src="@/assets/hideImg.png"
            alt=""
          />
          <img
            v-else
            @click="data.passwordType = 'password'"
            src="@/assets/showImg.png"
            alt=""
          />
        </div>
      </template>
    </van-field>
    <div class="forgetThePassword" @click="data.goForgetPasswordLink">
      忘记密码?
    </div>
  </div>
  <div class="login" @click="data.login">登录</div>
  <!-- <div class="register" v-if="!data.registerFlage">还没有账号？<span @click="data.register">立即注册</span></div> -->
  <div class="checkbox" :style="data.style">
    <van-checkbox v-model="data.checkbox"
      ><span style="color: #ffffff">我已阅读并同意</span
      ><span @click.stop="data.open('user')">《用户服务协议》</span
      ><span style="color: #ffffff">及</span
      ><span @click.stop="data.open('conceal')"
        >《隐私协议》</span
      ></van-checkbox
    >
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  nextTick,
} from "vue";
import { useCounterStore } from "@/store";
import { useRoute, useRouter } from "vue-router";
import headerMenu from "@/components/headerMenu.vue";
import { sendSmsCode, login, userInfo, passwordLogin } from "@/api/login";
import { showSuccessToast, showFailToast } from "vant";
import cross from "@/assets/cross.png";
import surres from "@/assets/surres.png";
import { setToken, getToken } from "@/ulits/auth";
/**
 * 仓库
 */
const store = useCounterStore();
/**
 * 路由对象
 */
const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
 * 数据部分
 */
const data = reactive({});
data.phoneTextFlag = false;
data.phoneCodeValueFlag = false;
data.viewPortHeight = "";
data.style = "";
data.phone = "";
data.phoneCode = "";
data.password = "";
data.checkbox = false;
data.registerFlage = false;
data.innerHeightFlag = false;
data.passwordValueFlag = false;
data.loginType = "codeLogin";
data.passwordType = "password";
// 注册
data.register = () => {
  data.phone = "";
  data.phoneCode = "";
  data.checkbox = false;
  data.registerFlage = true;
};

// 获取验证码
data.getCode = () => {
  const phoneReg = /^1[3-9]\d{9}$/;
  if (data.phone && phoneReg.test(data.phone)) {
    if (store.codeTimeFlag) {
      sendSmsCode({ phone: data.phone, type: 1 }).then((res) => {
        if (res.code === 200) {
          showFailToast({
            message: res.message,
            icon: surres,
          });
          store.codeTimeFunction();
        }
      });
    }
  } else {
    showFailToast({
      message: "请输入正确的手机号",
      icon: cross,
    });
  }
};

data.login = () => {
  if (!data.checkbox) {
    showFailToast({
      message: "请先同意用户协议与隐私协议",
      icon: cross,
    });
    return;
  }
  const phoneReg = /^1[3-9]\d{9}$/;
  if (!phoneReg.test(data.phone)) {
    showFailToast({
      message: "请输入正确的手机号",
      icon: cross,
    });
    return;
  }
  if (data.loginType === "codeLogin") {
    if (!data.phoneCode) {
      showFailToast({
        message: "请输入验证码",
        icon: cross,
      });
      return;
    }
    login({
      phone: data.phone,
      sms_code: Number(data.phoneCode),
      invite_code: sessionStorage.getItem("nviteCode")
        ? sessionStorage.getItem("nviteCode")
        : "",
    }).then((res) => {
      if (res.code === 200) {
        store.getUserinfo(res.data.user_info.id);
        sessionStorage.removeItem("nviteCode");
        setToken(res.data.token, 7);
        let path = localStorage.getItem("path");
        if (path) {
          router.go(-1);
          localStorage.removeItem("path");
        } else {
          router.replace({
            name: "home",
          });
        }
        showSuccessToast({
          message: "登录成功",
          icon: surres,
        });
      }
    });
  } else {
    if (!data.password) {
      showFailToast({
        message: "请输入密码",
        icon: cross,
      });
      return;
    }
    passwordLogin({
      phone: data.phone,
      password: data.password,
    }).then((res) => {
      if (res.code === 200) {
        store.getUserinfo(res.data.user_info.id);
        setToken(res.data.token, 7);
        let path = localStorage.getItem("path");
        if (path) {
          router.go(-1);
          localStorage.removeItem("path");
        } else {
          router.replace({
            name: "home",
          });
        }
        showSuccessToast({
          message: "登录成功",
          icon: surres,
        });
      }
    });
  }
};

data.input = () => {
  data.password = data.password.trim();
};

data.goForgetPasswordLink = () => {
  router.push({
    name: "forgetPassword",
  });
};

data.phoneValue = (e) => {
  if (e) {
    data.phoneTextFlag = true;
  } else {
    data.phoneTextFlag = false;
  }
};

data.phoneCodeValue = (e) => {
  if (e) {
    data.phoneCodeValueFlag = true;
  } else {
    data.phoneCodeValueFlag = false;
  }
};

data.passwordValue = (e) => {
  if (e) {
    data.passwordValueFlag = true;
  } else {
    data.passwordValueFlag = false;
  }
};

data.open = (e) => {
  if (e === "conceal") {
    window.open("https://huajiwang.feishu.cn/wiki/TZZEwVUp0i6I1ckmuqucK6Mmncb");
  } else {
    window.open("https://huajiwang.feishu.cn/wiki/LBHgwNFspidaWZkBPHzcQKCBnwe");
  }
};

if (window.innerHeight <= 720) {
  data.innerHeightFlag = true;
}

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  data.viewPortHeight = window.innerHeight;
  window.addEventListener("resize", function (event) {
    // 在此处添加对resize事件处理的代码
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android
    if (isAndroid) {
      let viewPortHeight = window.innerHeight;
      if (viewPortHeight === data.viewPortHeight) {
        this.setTimeout(() => {
          data.style = "";
        });
      } else {
        data.style = "bottom:-100px";
      }
    }
  });
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});
watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.loginMain {
  height: 100vh;
}
.headSculpture {
  width: 168px;
  height: 168px;
  margin: 0 auto;
  margin-top: 58px;
  img {
    width: 168px;
    height: 168px;
  }
}
.registerTitle {
  margin-top: 88px;
  font-weight: 500;
  color: #ffffff;
  font-size: 48px;
  text-align: center;
  position: relative;
}
.registerTitle::after {
  content: "";
  display: block;
  width: 192px;
  height: 8px;
  background: #8368fc;
  border-radius: 8px;
  left: calc(50% - 96px);
  bottom: 7px;
  position: absolute;
  z-index: -1;
}
.title {
  margin-top: 48px;
  font-weight: 400;
  color: #ffffff;
  font-size: 30px;
  text-align: center;
}
.van-cell {
  margin: 0 64px;
  width: auto;
  height: 88px;
  line-height: 88px;
  background: #323647;
  border-radius: 24px;
  margin-top: 48px;
  padding: 0 32px;
  color: #f7f5ff;
  font-size: 28px;
  ::v-deep().van-field__body {
    .van-field__control {
      color: #f7f5ff;
    }
    .van-icon {
      font-size: 30px;
    }
  }
  .btn {
    font-weight: 400;
    color: #8368fc;
  }
}
.van-cell:after {
  display: none;
}
.forgetThePassword {
  color: #8368fc;
  text-align: right;
  padding: 0 64px;
  font-size: 26px;
  margin-top: 40px;
  font-weight: 300;
}
.login {
  width: 622px;
  height: 88px;
  background: #8368fc;
  border-radius: 44px;
  font-weight: 500;
  color: #ffffff;
  font-size: 34px;
  text-align: center;
  line-height: 88px;
  margin: auto;
  margin-top: 44px;
}
.register {
  font-weight: 400;
  color: #ffffff;
  font-size: 26px;
  margin-top: 34px;
  text-align: center;
  span {
    color: #8368fcff;
    text-decoration: underline;
  }
}
.m-t100 {
  margin-top: 100px !important;
}
.checkbox {
  position: absolute;
  bottom: 0px;
  margin-top: 250px;
  width: 100vw;
  bottom: 32px;
  .van-checkbox {
    font-size: 28px;
    display: flex;
    justify-content: center;
    span {
      color: #8368fcff;
    }
  }
}
::v-deep().van-checkbox__icon {
  height: 36px;
  width: 36px;
  font-size: 36px;
  .van-icon {
    height: 36px;
    width: 36px;
  }
}
.textCorol {
  color: #ffffff !important;
  ::v-deep() .van-cell__title {
    // height: 20px;
    line-height: 40px;
  }
  ::v-deep().van-field__control {
    font-size: 24px !important;
    font-weight: 300 !important;
  }
}

.four {
  ::v-deep().van-field__label {
    color: #f7f5ff60 !important;
  }
  ::v-deep().van-field__control {
    font-weight: 300 !important;
    font-size: 34px !important;
  }
}
.tabs {
  margin-top: 40px;
  display: flex;
  color: #f7f5ff;
  font-size: 34px;
  font-weight: 300;
  padding: 0 64px;
  .item:nth-child(1) {
    margin-right: 48px;
  }
  .quitItem {
    font-weight: 400;
    color: #ffffff;
    position: relative;
  }
  .quitItem::after {
    content: "";
    z-index: -1;
    position: absolute;
    left: 0;
    bottom: 3px;
    width: 100%;
    height: 8px;
    background: #8368fc;
  }
}
.switch {
  display: flex;
  align-items: center;
  img {
    width: 48px;
    height: 48px;
  }
}
</style>
